import GTMService from './gtm-service';
import MainMenuEvents from './main-menu-events';
import FooterEvents from './footer-events';
import SocialShareEvents from './social-share-events';
import TagEvents from './tag-events';

import LanguageEvents from './language-events';
import LinkEvents from './link-events';
import BtnEvents from './btn-events';
import FilterEvents from './filter-events';
import SecondMenuEvents from './second-menu-events';
import ContentEvents from './content-events';
import HospitalitySuitsEvents from './hospitality-suits-events';
import TourDetailsEvents from './tour-details-events';

export default [
    new GTMService(),
    new MainMenuEvents(),
    new FooterEvents(),
    new SocialShareEvents(),
    new TagEvents(),
    new LanguageEvents(),
    new LinkEvents(),
    new BtnEvents(),
    new FilterEvents(),
    new SecondMenuEvents(),
    new ContentEvents(),
    new HospitalitySuitsEvents(),
    new TourDetailsEvents(),
];
